import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ThemeProvider from "./theme";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { ToastContainer } from "react-toastify";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";
import { getApp } from "firebase/app";
import "react-toastify/dist/ReactToastify.css";

// Initialize Firebase App Check (enterprise) if a site key is provided
try {
  const siteKey = process.env.REACT_APP_RECAPTCHA_ENTERPRISE_KEY;
  if (siteKey) {
    // This will no-op if called more than once
    initializeAppCheck(getApp(), {
      provider: new ReCaptchaEnterpriseProvider(siteKey),
      isTokenAutoRefreshEnabled: true,
    });
  }
} catch (_e) {
  // App Check initialization is optional; proceed without it if unavailable
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <LocalizationProvider dateAdapter={AdapterLuxon}>
        <App />
        <ToastContainer />
      </LocalizationProvider>
    </ThemeProvider>
  </React.StrictMode>,
);

reportWebVitals();
